// extracted by mini-css-extract-plugin
export var icon = "_5s-1";
export var subtext = "_5s-0";